import * as React from 'react'

import Modal, { ModalProps as MuiModalProps } from '@mui/material/Modal'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import IconButton from 'components/atomic/atoms/icon-button'
import Text from 'components/atomic/atoms/text'

const ModalContent = styled(Box)`
    position: absolute;
    top: 40%;
    left: 50%;
    width: 680px;
    max-width: 90%;
    min-height: 320px;
    transform: translate(-50%, -40%);
    background-color: #0a131e;
    box-shadow: 24px;
    padding: 1.55rem;
    border-radius: 1.5rem;
`

const Head = styled('div')`
    display: flex;
    column-gap: 1rem;
    justify-content: space-between;
    align-items: flex-start;
`

interface ModalProps extends MuiModalProps {
    title?: string
    subtitle?: string
    hideClose?: boolean
}

export default function BasicModal(props: ModalProps) {
    const { hideClose = false, title, subtitle, children, onClose, open } = props

    return (
        <Modal
            open={open}
            onClose={(e) => onClose && onClose(e, 'backdropClick')}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } } }}>
            <ModalContent>
                <Head>
                    <div>
                        {title ? (
                            <Text variant="h5" style={{ marginBottom: '1rem' }}>
                                {title}
                            </Text>
                        ) : null}
                        {subtitle ? <Text>{subtitle}</Text> : null}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        {!hideClose ? (
                            <IconButton
                                aria-label="Close modal"
                                icon="close"
                                onClick={(e) => onClose && onClose(e, 'backdropClick')}
                                color="inherit"
                            />
                        ) : null}
                    </div>
                </Head>
                {children}
            </ModalContent>
        </Modal>
    )
}
